import { FormType } from '../../../form-types';

export const wlusMonthlyOral: FormType = {
  name: 'Weight Loss Oral Drops Follow up',
  olderVersions: ['wlusMonthlyOral_2024'],
  questions: [
    {
      key: 'wlusFollowup_genderIdentify',
      next: {
        condition: {
          'wlusFollowup_genderIdentify.wlusFollowup_genderIdentify_male': true
        },
        key: 'wlusFollowup_weightAndHeight2025',
        els: 'wlusFollowup_pregnantOrBreastfeedingOrPlanningTo'
      }
    },
    {
      key: 'wlusFollowup_pregnantOrBreastfeedingOrPlanningTo',
      next: {
        condition: {
          'wlusFollowup_pregnantOrBreastfeedingOrPlanningTo.wlusFollowup_PregnantOrBreastfeedingOrPlanningTo_yes':
            true
        },
        key: 'wlusFollowup_ineligible',
        els: 'wlusFollowup_consentPregnancy'
      }
    },
    {
      key: 'wlusFollowup_consentPregnancy',
      next: {
        condition: {
          'wlusFollowup_consentPregnancy.wlusFollowup_consentPregnancy_non_consent':
            true
        },
        key: 'wlusFollowup_didNotConsent',
        els: 'wlusFollowup_weightAndHeight2025'
      }
    },
    'wlusFollowup_weightAndHeight2025',
    {
      key: 'wlusFollowup_consentBmi',
      next: {
        condition: {
          'wlusFollowup_consentBmi.wlusFollowup_consentBmi_consent': true
        },
        key: 'wlusFollowup_healthChangesMedicationChangesEdVisitsOrHospitalizationsSinceYourLastCheckIn',
        els: 'wlusFollowup_ineligible'
      }
    },
    {
      key: 'wlusFollowup_healthChangesMedicationChangesEdVisitsOrHospitalizationsSinceYourLastCheckIn',
      next: {
        condition: {
          'wlusFollowup_healthChangesMedicationChangesEdVisitsOrHospitalizationsSinceYourLastCheckIn.wlusFollowup_healthChangesMedicationChangesEdVisitsOrHospitalizationsSinceYourLastCheckIn_yes':
            true
        },
        key: 'wlusFollowup_tellUsMoreAboutTheChangesInYourHealth',
        els: 'wlusFollowup_hadAGastricBypassInThePast6Months'
      }
    },
    'wlusFollowup_tellUsMoreAboutTheChangesInYourHealth',
    {
      key: 'wlusFollowup_hadAGastricBypassInThePast6Months',
      next: {
        condition: {
          'wlusFollowup_hadAGastricBypassInThePast6Months.wlusFollowup_hadAGastricBypassInThePast6Months_yes':
            true
        },
        key: 'wlusFollowup_ineligible',
        els: 'wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication'
      }
    },
    'wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication',
    {
      key: 'wlusFollowup_haveYouExperiencedSideEffectsFromYourCurrentMedication',
      next: {
        condition: {
          'wlusFollowup_haveYouExperiencedSideEffectsFromYourCurrentMedication.wlusFollowup_haveYouExperiencedSideEffectsFromYourCurrentMedication_yes':
            true
        },
        key: 'wlusFollowup_describeTheSideEffectsThatYouVeExperienced',
        els: 'wlusFollowup_medicationExperience'
      }
    },
    'wlusFollowup_describeTheSideEffectsThatYouVeExperienced',
    {
      key: 'wlusFollowup_medicationExperience',
      next: {
        condition: {
          'wlusFollowup_medicationExperience.sharedDecision': true
        },
        key: 'wlusFollowup_sharedDecisionMaking',
        els: 'wlusFollowup_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose'
      }
    },
    'wlusFollowup_sharedDecisionMaking',
    'wlusFollowup_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose',
    'wlusFollowup_areYouExperiencingAReductionInFoodCravingsWithThisDose',
    'wlusFollowup_otherInformationOrQuestionsDoYouHaveForTheDoctor',
    {
      key: 'wlusFollowup_consentTruthfulness',
      next: {
        condition: {
          'wlusFollowup_consentTruthfulness.wlusFollowup_consentTruthfulness_non_consent':
            true
        },
        key: 'wlusFollowup_didNotConsent',
        els: 'wlusFollowup_consentGLP1GIP'
      }
    },
    {
      key: 'wlusFollowup_consentGLP1GIP',
      next: {
        condition: {
          'wlusFollowup_consentGLP1GIP.wlusFollowup_consentGLP1GIP_non_consent':
            true
        },
        key: 'wlusFollowup_didNotConsent',
        els: 'wlusFollowup_complete'
      }
    },
    'wlusFollowup_ineligible',
    'wlusFollowup_didNotConsent',
    'wlusFollowup_complete'
  ]
};
